/**
 * 模态框管理 Hook
 */

import { useState, useCallback } from 'react';

interface UseModalOptions {
  defaultVisible?: boolean;
}

export function useModal(options?: UseModalOptions) {
  const [visible, setVisible] = useState(options?.defaultVisible || false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = useCallback(() => {
    setVisible(true);
  }, []);

  const hideModal = useCallback(() => {
    setVisible(false);
    setConfirmLoading(false);
  }, []);

  const startConfirmLoading = useCallback(() => {
    setConfirmLoading(true);
  }, []);

  const stopConfirmLoading = useCallback(() => {
    setConfirmLoading(false);
  }, []);

  const handleOk = useCallback(async (onConfirm?: () => Promise<void> | void) => {
    startConfirmLoading();
    try {
      if (onConfirm) {
        await onConfirm();
      }
      hideModal();
    } catch (error) {
      console.error('操作失败:', error);
      stopConfirmLoading();
      throw error;
    }
  }, [startConfirmLoading, stopConfirmLoading, hideModal]);

  const handleCancel = useCallback(() => {
    hideModal();
  }, [hideModal]);

  return {
    visible,
    confirmLoading,
    showModal,
    hideModal,
    handleOk,
    handleCancel,
    startConfirmLoading,
    stopConfirmLoading,
  };
}
